/* eslint-disable unused-imports/no-unused-imports */
import React, {memo, Suspense} from "react"
import {useTemplatedComponent, TemplateSettingsModel} from "@next/templating"
import {MANIFEST} from "@manifest/product-summary"
import {TextModel} from "models/Text"
import connect from "./connect"
import useGTMOnHydrate from "../hooks/useGTMOnHydrate"
import {SuitType, ProductType, SofaType, BundleType} from "../config/constants"
import {RequestState} from "../models/Request"
import {ItemOptionLiteContract} from "../models/searchApi/itemLite"

export interface ProductSummaryProps {
    template: TemplateSettingsModel
    text: TextModel
    itemNumber: string
    firstItemNumber: string
    productType: typeof SuitType | typeof ProductType | typeof SofaType | typeof BundleType
    enableBrandDisplay: boolean
    brand: string
    colourwaysHasSale: boolean
    colourwaysHasRating: boolean
    colourwaysHasStarRatingWithRangedPrice: boolean
    linkUrl: string
    title: string
    price: string
    colour?: string
    currencyCode: string
    department: string
    tooltipTitle: string
    overallStarRating: number
    ratingText: string
    enableReviewStars: boolean
    enableSingleLineTitle: boolean
    numberOfAllColourways: number
    enableSingleLineBrandName: boolean
    client: string
    request: RequestState
    sizeOptionSelected: ItemOptionLiteContract
    onSelectOption: (option: ItemOptionLiteContract) => void
    options: ItemOptionLiteContract[]
    enableQuickAddToBag: boolean
}

export const ProductSummary = memo(({template, ...props}: ProductSummaryProps) => {
    const ProductSummaryComponent = useTemplatedComponent(template, MANIFEST)

    useGTMOnHydrate()

    return (
        <Suspense>
            <ProductSummaryComponent {...props} />
        </Suspense>
    )
})
ProductSummary.displayName = "ProductSummary"

export default connect(ProductSummary as any)
